// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"245":"component---src-pages-index-tsx","439":"5a699099","453":"component---src-pages-404-tsx"}[chunkId] || chunkId) + "-" + {"39":"41d26f4e8f810d98a567","245":"a812b2a5b97e0de347da","439":"565df43288a6ffa0cd06","453":"c01e1f1123161cdfe536"}[chunkId] + ".js";
};